import { useEffect } from "react";
import { SITE_URL } from "../data/siteContent";

const DEFAULT_TITLE = "SVS College of Nursing | Bokaro, Jharkhand";
const DEFAULT_DESC =
  "SVS College of Nursing, Bokaro — Excellence in ANM, GNM & B.Sc Nursing education. Admissions open 2026-27. Recognised by INC, Jharkhand Nurses Registration Council & BBMKU.";

function upsertMeta(attr, name, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SEO({ title, description, path, jsonLd = [] }) {
  const jsonLdKey = JSON.stringify(jsonLd);

  useEffect(() => {
    document.title = title || DEFAULT_TITLE;
    upsertMeta("name", "description", description || DEFAULT_DESC);
    upsertMeta("property", "og:title", title || DEFAULT_TITLE);
    upsertMeta("property", "og:description", description || DEFAULT_DESC);
    if (path) {
      upsertMeta("property", "og:url", SITE_URL + path);
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", SITE_URL + path);
    }
    const injected = jsonLd.map((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-page-jsonld", "");
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
      return s;
    });
    return () => {
      document.title = DEFAULT_TITLE;
      upsertMeta("name", "description", DEFAULT_DESC);
      injected.forEach((s) => s.remove());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, jsonLdKey]);

  return null;
}
